import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnerPageTemplate from "@/components/partners/PartnerPageTemplate";
import { operationHope } from "@/data/partners";

export const Route = createFileRoute("/partners/operation-hope")({
  head: () => seoHead("/partners/operation-hope"),
  component: () => <PartnerPageTemplate partner={operationHope} />,
});
